module.exports = __webpack_public_path__ + "static/img/wangzhan_contente.3c76a2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/wangzhan_contente.png
// module id = mjrT
// module chunks = 0